<template>
  <div class="auth_wrapper">
    <LoginToolbar />
    <div class="login-page justify-center align-center d-flex">
      <router-view />
    </div>
  </div>
</template>

<script>
import { LANGUAGES } from "@/utils/constants";
import { setLanguageToLocalStorage } from "@/utils/pureFunctions";
import "hooper/dist/hooper.css";
import LoginToolbar from "@/components/layout/LoginToolbar.vue";
export default {
  components: { LoginToolbar },
  computed: {
    LANGUAGES: () => LANGUAGES,
  },
  watch: {
    "$i18n.locale"(val) {
      setLanguageToLocalStorage(val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/login.scss";
</style>
